// components/shared/Badge.jsx
export function Badge({ children, variant = "default", className = "" }) {
  const variants = {
    default: "bg-slate-600/10 text-slate-300 border-slate-500/25",
    success: "bg-green-600/10 text-green-300 border-green-500/25",
    danger: "bg-red-600/10 text-red-300 border-red-500/25",
    warning: "bg-yellow-600/10 text-yellow-200 border-yellow-500/25",
    info: "bg-blue-600/10 text-blue-300 border-blue-500/25",
  };

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 text-xs font-semibold rounded-full border ${variants[variant]} ${className}`}
    >
      {children}
    </span>
  );
}
